const AUTH_URL = import.meta.env.VITE_AUTH_URL ?? ""

interface ConfiguracaoPublica {
  chave: string
  valor: string
}

/**
 * Lê as configurações públicas do sigi-auth sem autenticação (branding e
 * preferências globais como o tema inicial). Falhas de rede não bloqueiam o
 * carregamento da aplicação.
 */
export async function obterConfiguracoesPublicas(): Promise<Record<string, string>> {
  try {
    const resposta = await fetch(`${AUTH_URL}/api/v1/configuracoes/publicas`, {
      headers: { Accept: "application/json" },
    })
    if (!resposta.ok) return {}
    const dados = (await resposta.json()) as ConfiguracaoPublica[]
    return Object.fromEntries(
      dados
        .filter((item) => typeof item.chave === "string" && typeof item.valor === "string")
        .map((item) => [item.chave, item.valor]),
    )
  } catch {
    return {}
  }
}

/** Tema inicial configurado pelo administrador, quando válido. */
export async function obterTemaPadrao(): Promise<"light" | "dark" | "system" | null> {
  const configuracoes = await obterConfiguracoesPublicas()
  const tema = configuracoes["tema.padrao"]
  return tema === "light" || tema === "dark" || tema === "system" ? tema : null
}
